import request from '@/utils/request' //引入封装好的 axios 请求

// 银行发布产品
export function addProduct (data = {}) {
    return request({
        url: '/api/credit/product/operate',
        method: 'post',
        data: data
    })
}

// 贷款类型
export function getProductType (data = {}) {
    return request({
        url: '/api/credit/dictionary/selectByCode',
        method: 'post',
        params: data
    })
}

//
export function getProductList (data = {}) {
    return request({
        url: '/api/credit/product/list',
        method: 'post',
        params: data
    })
}

// 获取字典名称
export function getDictName (data = {}) {
    return request({
        url: '/api/credit/dictionary/getDictionaryByCode',
        method: 'post',
        params: data
    })
}


// 获取不同状态产品列表
export function list (data = {}) {
    return request({
        url: '/api/credit/product/list',
        method: 'post',
        data
    })
}

// 修改产品属性
export function detail (data = {}) {
    return request({
        url: '/api/credit/product/detail',
        method: 'post',
        data
    })
}


//上报成效
export function reportInformation (data = {}) {
    return request({
        url: '/api/credit/product/reportInformation',
        method: 'post',
        data
    })
}


//产品类型
export function selectProType (data = {}) {
    return request({
        url: '/api/credit/product/selectProType',
        method: 'post',
        data
    })
}



//查询当前产品可修改状态
export function existExamine (data = {}) {
    return request({
        url: '/api/credit/product/existExamine',
        method: 'post',
        data
    })
}

//查询历史列表
export function selectHistoryList (data = {}) {
    return request({
        url: '/api/credit/product/selectHistoryList',
        method: 'post',
        data
    })
}


